import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";
import { PlantLocation } from "../locations/locations.service";

export interface PlantPerformanceService {
  getPackChartData(location: PlantLocation, month: string): angular.IPromise<apsViewModels.PackToMeltInfo>;
  getSnapshotData(): angular.IPromise<apsViewModels.Snapshot>;
  getPackProductsInfo(location: PlantLocation, month: string): angular.IPromise<apsViewModels.PackProductsInfo>;
  getFurnaceChartData(location: PlantLocation, month: string): angular.IPromise<apsViewModels.FurnaceUtilizationInfo>;
  getLineItemHoldsData(location: PlantLocation, month: string): angular.IPromise<apsViewModels.LineHoldItem[]>;
}

class PlantPerformanceServiceImpl implements PlantPerformanceService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  getPackChartData(location: PlantLocation, month: string) {
    return this.httpService.get<apsViewModels.PackToMeltInfo>(
      Endpoints.PACK_CHART_INFO,
      {
        selectedMonth: month,
        locationId: location.id,
        locationType: location.locationType
      });
  }

  getSnapshotData() {
    return this.httpService.get<apsViewModels.Snapshot>(Endpoints.PLANT_PERFORMANCE_SNAPSHOT);
  }

  getPackProductsInfo(location: PlantLocation, month: string) {
    return this.httpService.get<apsViewModels.PackProductsInfo>(
      Endpoints.PACK_PRODUCTS_INFO,
      {
        selectedMonth: month,
        locationId: location.id,
        locationType: location.locationType
      });
  }

  getFurnaceChartData(location: PlantLocation, month: string) {
    return this.httpService.get<apsViewModels.FurnaceUtilizationInfo>(
      Endpoints.FURNACE_CHART_INFO,
      {
        selectedMonth: month,
        locationId: location.id,
        locationType: location.locationType
      });
  }

  getLineItemHoldsData(location: PlantLocation, month: string) {
    return this.httpService.get<apsViewModels.LineHoldItem[]>(
      Endpoints.LINE_ITEM_HOLDS_DATA,
      {
        selectedMonth: month,
        locationId: location.id,
        locationType: location.locationType
      });
  }
}

export default angular
  .module('aps.services.plantPerformance', [HttpServiceName])
  .service('plantPerformanceService', PlantPerformanceServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/dashboard/plantPerformance.service.ts